export default __webpack_public_path__ + "static/media/DC_Logo.37ec3d1e.png";